import * as React from "react";
import { IconButton } from "react-native-paper";
import { StyleSheet, View } from "react-native";
import { blackColor } from "./../../common/colors";
import Icon from "react-native-vector-icons/AntDesign";
import resolutionMargin from "../resolutionMargin";

export default ({ back, close, isBackDisabled, isButtonBackHidden }) => {
  return (
    <View style={styles.icons}>
      {!isButtonBackHidden ? <IconButton
        icon={() => <Icon name="left" size={24} color={blackColor}></Icon>}
        size={20}
        onPress={back}
        disabled={isBackDisabled}
      />: <View />}
      <IconButton
        icon={() => <Icon name="close" size={24} color={blackColor}></Icon>}
        size={20}
        onPress={close}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: resolutionMargin(),
  },
});
